import React from "react";
import Checkbox from "@visa/vds/checkbox";
import CheckboxList from "@visa/vds/checkbox-list";
import CheckboxListItem from "@visa/vds/checkbox-list-item";
import CheckboxSet from "@visa/vds/checkbox-set";
import CheckboxSetLegend from "@visa/vds/checkbox-set-legend";
import Typography from "@visa/vds/typography";

function FilterSection(props) {
  return (
    <>
      <CheckboxSet>
        <CheckboxSetLegend>
          <Typography tag="h4" variant="subtitle--alt">
            Filter By
          </Typography>
        </CheckboxSetLegend>
        <CheckboxList>
          {props.tags.items &&
            props.tags.items.map((item, k) => (
              <CheckboxListItem key={k}>
                <Checkbox
                  name={item.name}
                  label={item.name}
                  checked={item.checked}
                  onChange={(e) => {
                    props.handleChange(e);
                  }}
                />
              </CheckboxListItem>
            ))}
        </CheckboxList>
      </CheckboxSet>
    </>
  );
}

export default FilterSection;
